import PropTypes from 'prop-types';


const autocompleteDefaultProperties = {
  autocompleteParams: {
    suggestions: [],
    tokens: []
  },
  showAutocomplete: false,
  actions: {
    autocomplete: {
      fetchList: () => {},
      addTag: () => {},
      addCustomTag: () => {},
      removeTag: () => {},
      show: () => {},
      hide: () => {},
      generate: () => {},
      updateValue: () => {}
    }
  },
  name: '',
  placeholder: ''
};

const autocompletePropertyTypes = {
  autocompleteParams: PropTypes.shape({
    suggestions: PropTypes.array,
    tokens: PropTypes.array
  }),
  showAutocomplete: PropTypes.bool,
  actions: PropTypes.shape({
    autocomplete: PropTypes.object
  }),
  name: PropTypes.string,
  placeholder: PropTypes.string
};

export {
  autocompleteDefaultProperties,
  autocompletePropertyTypes
};
